import { EStorageKeys } from '@qsp-ui-library/models/enums/storage-keys.enum';
import { AppAuthenticationService } from '@qsp-ui-library/services/user-services/app-authentication/app-authentication.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie';

@Injectable({ providedIn: 'root' })
export class AuthoritiesGuard implements CanActivate {
  public constructor(
    private readonly _cookieStorage: CookieService,
    private readonly _appAuthenticationService: AppAuthenticationService
  ) {}

  public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
    const userId = this._cookieStorage.get(EStorageKeys.USER_ID);
    const token = this._cookieStorage.get(EStorageKeys.AUTH_TOKEN);

    if (userId && token) {
      return true;
    }

    this._appAuthenticationService.navigateToLogin(state.url);

    return false;
  }
}
